import "styles/landing-pages/howItWorks.less";
import { useContext, useState } from "react";

import { Card, Col, Collapse, Row, Flex, Divider } from "antd";
import { AppContext } from "App";
import constructionWorker from "assets/images/home/construction-worker.svg";
import freelancer from "assets/images/home/freelancer.svg";
import girlWithIpadImage from "assets/images/home/girl-with-ipad.png";
import howItWorksImageMobile from "assets/images/home/how-it-works-mobile.svg";
import howItWorksImage from "assets/images/home/how-it-works.svg";
import ipadImage from "assets/images/home/ipad.png";
import landlord from "assets/images/home/landlord.svg";
import laptopImage from "assets/images/home/laptop-image.svg";
import manOnDesktopImage from "assets/images/home/man-on-desktop.png";
import productDemo from "assets/images/home/product-demo.svg";
import soleTrader from "assets/images/home/sole-trader.svg";
const { Panel } = Collapse;

const HowItWorks = () => {
    const { isMobile } = useContext(AppContext);
    const [activeKey, setActiveKey] = useState<string>("1");

    const panelImages: Record<string, string> = {
        "1": laptopImage,
        "2": ipadImage,
        "3": girlWithIpadImage,
        "4": manOnDesktopImage,
    };

    const cardImage = panelImages[activeKey];

    const handlePanelChange = (key: string | string[]) => {
        if (key.length !== 0) {
            setActiveKey(key as string);
        }
    };

    const professionCards = [
        { title: "Sole Trader", content: "Easily add income, claim every expense, and file your self-assessment fast.", icon: soleTrader },
        { title: "Landlord", content: "Track rental income, maximise property deductions, and simplify your tax return.", icon: landlord },
        { title: "Construction Worker", content: "Handle CIS deductions, report your earnings accurately, and maximize your tax refunds.", icon: constructionWorker },
        { title: "Freelancer", content: "Track client income and expenses to simplify your annual filing.", icon: freelancer },
    ];

    return (
        <div className="how-it-works flex-column center">
            <img src={isMobile ? howItWorksImageMobile : howItWorksImage} alt="How it works illustration" />
            <div className="section-title mt30">All Ways to Earn. One Way to File.</div>
            <p className="fs18 grey-8-color">TaxZap is for everyday folks who’d rather be doing literally anything else than wrestling with tax forms. Whether you’re a...</p>

            <Row gutter={[16, 16]}>
                {professionCards.map((card, index) => (
                    <Col key={index} xs={12} sm={12} md={6}>
                        <div className="h100">
                            <Card bordered className="how-it-works__card" bodyStyle={{ padding: 16 }}>
                                <div>
                                    <img src={card.icon} alt={`${card.title} icon`} />
                                </div>
                                <h3 className="how-it-works__card-title">{card.title}</h3>
                                <p className="how-it-works__card-content">
                                    {card.content}
                                </p>
                            </Card>
                        </div>
                    </Col>
                ))}
            </Row>

            <Card className="how-it-works__card w100 mt30 w100" bordered={false} bodyStyle={{ padding: 0 }}>
                <Flex justify="space-between" align="stretch" className="w100">
                    <div style={{ flex: 1 }} className="w100">

                        <Collapse
                            accordion
                            ghost
                            className="p20 w100"
                            expandIconPosition="end"
                            activeKey={activeKey}
                            onChange={handlePanelChange}
                        >
                            <Panel header="Fast & Effortless Filing" key="1" className="how-it-works__card-title how-it-works__panel-heading">
                                <span className="how-it-works__card-content">
                                Skip the stress and confusion. TaxZap guides you step-by-step so you can complete your tax return quickly and easily. No tax knowledge needed.
                                </span>
                            </Panel>
                            <Panel header="Save on Your Tax Bill" key="2" className="how-it-works__card-title how-it-works__panel-heading">
                                <span className="how-it-works__card-content">
                                TaxZap automatically checks for every credit, deduction, and tax relief that applies to your unique situation.
                                </span>
                            </Panel>
                            <Panel header="All Income Types, One Place" key="3" className="how-it-works__card-title how-it-works__panel-heading">
                                <span className="how-it-works__card-content">
                                Wages, self-employment, rental income, CIS or freelance gigs... TaxZap handles it all in one simple tax return.
                                </span>
                            </Panel>
                            <Panel header="Real People, Real Help" key="4" className="how-it-works__card-title how-it-works__panel-heading">
                                <span className="how-it-works__card-content">
                                Stuck on a question? Not sure what to enter? We’ve got you. Get instant answers anytime with our smart support bot Zappy.
                                </span>
                                <br/>
                                <span className="how-it-works__card-content">
                                Still need help? Chat with a real human tax expert. You’re never left guessing.</span>
                            </Panel>
                        </Collapse>
                    </div>
                    {!isMobile && <div style={{ flex: 1 }}>
                        <div className="how-it-works__card-image">
                            <img src={cardImage} alt="how it works illustration"/>
                        </div>
                    </div>}
                </Flex>
            </Card>

            <div className="mt30 section-title">Submit Your Tax Return in <span className="secondary-color">3 Simple Steps</span></div>
            <p className="fs18 grey-8-color">No paperwork. No stress. Just a few clicks.</p>

            <Card className="how-it-works__card w100 mt30 w100" bordered={false} bodyStyle={{ padding: 16 }}>
                <Flex className="w100 h100">
                    <div style={{ flex: 1 }}>
                        <Card
                            className="how-it-works__card-content h100"
                            bordered={false}
                            bodyStyle={{ padding: 16 }}
                        >
                            <div className="how-it-works__card-sections">
                                <div>
                                    <div className="secondary-color uppercase">Step 1</div>
                                    <h3 className="how-it-works__card-title black-color">Share Your Info Your Way</h3>
                                    <p>Connect your bank account securely or upload your documents, whichever works best for you. We’ll grab what we need in seconds.</p>
                                </div>
                                <Divider />
                                <div>
                                    <div className="secondary-color uppercase">Step 2</div>
                                    <h3 className="how-it-works__card-title black-color">Answer a Few Easy Questions</h3>
                                    <p>No jargon or tricky forms. Just simple, guided questions anyone can follow, even if it’s your first time filing.</p>
                                </div>
                                <Divider />
                                <div>
                                    <div className="secondary-color uppercase">Step 3</div>
                                    <h3 className="how-it-works__card-title black-color">Click Submit and You’re Done</h3>
                                    <p>We’ll file your tax return directly with HMRC. Just review your info carefully, submit, and relax. Your taxes are taken care of.</p>
                                </div>
                            </div>
                        </Card>
                    </div>
                    {!isMobile && <div style={{ flex: 1 }}>
                        <div className="how-it-works__card-image">
                            <img src={productDemo} alt="how it works illustration"/>
                        </div>
                    </div>}
                </Flex>
            </Card>
        </div>
    );
};

export default HowItWorks;
